export default function getWebpageInfo() {
  return {
    webpageUrl: window.location.href,
    webpageTitle: document.querySelector('title').innerHTML,
  };
}
